<template>
  <!-- styles are bound in a way that baseStyle is always overwritten by customStyle
    and fontSizeStyle overwrites everything -->
  <li class="line" v-bind:style="[baseStyle, customStyle, fontSizeStyle]" v-text="text"/>

</template>

<script>
export default {
  name: 'Block',
  props: {
    text: String,
    type: Number,
    fontSize: Number
  },
  computed: {
    fontSizeStyle() {
      return {
        fontSize: this.fontSize + "px"
      }
    },
    baseStyle() {
      return this.$store.getters.getBaseStyle;
    },
    customStyle() {
      return this.$store.getters.getCustomStyle(this.type);
    }
  }
}
</script>
<style scoped>

  .line::after {
    content: "\A";
    white-space: pre;
  }
</style>



// WEBPACK FOOTER //
// Block.vue?a12ba418